import { Image } from "antd";
import type { ClipUploadImagePreviewState } from "./useClipUploadPreview";

export const ClipUploadImagePreview = ({ src, open, onOpenChange }: ClipUploadImagePreviewState) => {
  if (!src) return null;
  return (
    <Image
      src={src}
      styles={{ root: { display: "none" } }}
      preview={{
        visible: open,
        onOpenChange,
      }}
    />
  );
};
